import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { layoutTestDescriptor } from './descriptor.js';

export const layoutTestCatalogEntry = {
  descriptor: layoutTestDescriptor,
  availability: 'diagnostic',
  load: async () => (await import('./layout-test.js')).layoutTestDefinition,
} satisfies AvailableGameCatalogEntry;
